import {Form, Modal} from "antd";
import React, {useState} from "react";

/*
Submits on Modal OK,  disables during submit,  closes on success
 */

const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};

const tailLayout = {
    wrapperCol: { offset: layout.labelCol.span, span: layout.wrapperCol.span },
};

export default function ModalForm(
    {
        formProps,
        children,
        okText='Submit',
        form,
        ...props
    })
{
    //const [form] = Form.useForm();
    const [confirmLoading, setConfirmLoading] = useState();

    const {onCancel} = props;
    const {onFinish: onSuccess, onFinishFailed: onFailed, ...restFormProps} = formProps;

    const onOk = () => {
        setConfirmLoading(true);
        form.submit();
    };

    const onFinish = async (values) => {
        try {
            const res = await onSuccess(values);
            setConfirmLoading(false); //try here - needed
            onCancel();
            return res;
            // Note don't bother change loading - causes warning as unmounted already
        } catch (e) {
            setConfirmLoading(false);
            console.error(e);
        }
    };

    const onFinishFailed = async (data) => {
        try {
            return await onFailed(data);
        } catch (e) {
            // ?Failed failed - NOP
        } finally {
            setConfirmLoading(false);
        }
    };

    //Note; can be problems with initialValues if not dismounted higher up.
    //Using Modal.destroyOnClose with Form.preserver (see antd docs) didn't help either

    // todo Mask (?Spin) whole form while confirm loading
    return (
        <Modal onOk={onOk} okText={okText}
               confirmLoading={confirmLoading}
               {...props}
        >
            <Form form={form}
                  {...layout}
                  {...restFormProps}
                  {...{onFinish, onFinishFailed}}
            >{children}</Form>
        </Modal>
    );
}